export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8231.9a9b8d9c.jpg";